import React, {useEffect, useRef, useState} from 'react';
import {FaUser} from "react-icons/fa";
import {FaPowerOff} from "react-icons/fa";
import {unstable_setDevServerHooks, useNavigate} from "react-router-dom";
import apiRequests from "../axios/config/config";
import {FaAlignJustify} from "react-icons/fa6";
import SideBar from "../sidebar/sidebar";


export default function Header() {

    const [userName, setUserName] = useState("");

    const [showMenu, setShowMenu] = useState(false);


    useEffect(() => {

        if (!userName) {

            apiRequests.get("/api/admin/v1/get-my-profile")
                .then((res) => {
                    setUserName(res.data.data.firstName + " " + res.data.data.lastName);
                })
                .catch(() => {
                    setUserName("-")
                })
        }


    }, [userName]);

    function logOut () {
        localStorage.clear();
        window.location.reload();
    }

    return (
        <>

            <div className="flex items-center justify-center">

                <div
                    className="flex items-center justify-between bg-firstColor-shade4 text-white rounded-xl py-3 px-5 my-2 w-[60%] md:w-[90%]">

                    <div className="flex gap-3">

                        <button className="text-[18px] hidden md:block" onClick={() => setShowMenu(!showMenu)}>
                            <FaAlignJustify/>
                        </button>

                        <div className="flex gap-1 items-center">
                            <FaUser/>
                            {userName}
                        </div>
                    </div>

                    <div className="text-red-600 hover:cursor-pointer" onClick={logOut}>
                        <FaPowerOff/>
                    </div>

                </div>

            </div>

            {showMenu && <MenuTitle setHow={setShowMenu}/>}
        </>
    )
}



export function MenuTitle ({setHow}) {

    const dropdownRef = useRef(null);

    useEffect(() => {

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setHow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [dropdownRef]);

    return (

        <div className="hidden md:fixed md:z-10  md:flex md:top-0 md:bg-black md:bg-opacity-50 md:h-full md:w-full" >
            {/* Left-side clickable area to close the overlay */}
            <div
                className="md:text-black md:flex md:flex-col md:w-[70%] md:h-full md:bg-black md:rounded-r-[20px] md:gap-6"
                ref={dropdownRef}
            >
                <SideBar setShowMenuMobile={setHow}/>
            </div>

            <div className="w-[30%]"></div>

        </div>

    )

}